import { AverageJobRatingListDataType } from "../../redux/mySpace/mySpaceTypes";
import FullScreenDialog from "../commons/FullScreenDilog/FullScreenDilog";
import AverageJobRatingData from "./AverageJobRatingData";

type AppProps = {
  fetching: boolean;
  modal: boolean;
  toggleModal: () => void;
  mySpaceSuccess: number | null;
  averageJobRatingList: AverageJobRatingListDataType[] | [];
  averageJobRatingCount: number;
  averageJobRatingData: number;
};
const ViewMyJobRatingDetails = ({
  fetching,
  mySpaceSuccess,
  toggleModal,
  averageJobRatingList,
  averageJobRatingCount,
  averageJobRatingData,
}: AppProps) => {
  const handleAddMangerFeedback = () => {};

  const jobBody = () => {
    return (
      <>
        {
          <AverageJobRatingData
            fetching={fetching}
            averageJobRatingList={averageJobRatingList}
            averageJobRatingCount={averageJobRatingCount}
            averageJobRatingData={averageJobRatingData}
          />
        }
      </>
    );
  };

  return (
    <div>
      <FullScreenDialog
        success={mySpaceSuccess}
        onClose={toggleModal}
        showSchedulingEstimateData={averageJobRatingList}
        title={"My Job Rating"}
        body={jobBody}
        onSubmit={handleAddMangerFeedback}
      />
    </div>
  );
};

export default ViewMyJobRatingDetails;
